<template>
  <div class="quarter_div">
    <a-popover trigger="click" v-model="open">
      <div>
        <a-range-picker
          :allowClear="allowClear"
          :open="false"
          format="YYYY[Q]M"
          v-bind="$attrs"
          :mode="mode2"
          v-model="dateValue"
          @change="clearValue">
        </a-range-picker>
      </div>
      <div slot="content" class="picker_div">
        <a-row class="select_value">
          <a-col :span="24">
            {{showLeftYear+""+$t('proprietor.rentAndVacancyHistorey.quarters.'+showLeftQuarter)}}&nbsp;&nbsp;~&nbsp;&nbsp;{{showRightYear+""+$t('proprietor.rentAndVacancyHistorey.quarters.'+showRightQuarter)}}
          </a-col>
        </a-row>
        <div class="line"></div>
        <a-row class="year-select" :gutter="25">
          <a-col :span="12" class="year_select_col">
            <div class="icon" :class="{disabled:leftYear == minYear}" @click="leftYear = leftYear - 1"><a-icon type="double-left" /></div>
            <div>{{leftYear}}</div>
            <div class="icon" :class="{disabled:leftYear == maxYear}" @click="leftYear = leftYear + 1"><a-icon type="double-right" /></div>
          </a-col>
          <a-col :span="12" class="year_select_col">
            <div class="icon" :class="{disabled:rightYear == minYear}" @click="rightYear = rightYear - 1"><a-icon type="double-left" /></div>
            <div>{{rightYear}}</div>
            <div class="icon" :class="{disabled:rightYear == maxYear}" @click="rightYear = rightYear + 1"><a-icon type="double-right" /></div>
          </a-col>
        </a-row>
        <div class="line"></div>
        <a-row class="quarter_row">
          <a-col :span="12">
            <a-row style="padding-left: 30px;padding-right: 30px">
              <a-col class="quarter_col" v-for="i in 4" :span="12" :key="i">
                <div  @click="leftQuarterSelect(i)" class="quarter_item" :class="[leftSelectActive(i),leftSelectDisabled(i)]">
                  {{$t('proprietor.rentAndVacancyHistorey.quarters.'+(i))}}
                </div>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="12">
            <a-row style="padding-left: 30px;padding-right: 30px">
              <a-col class="quarter_col" v-for="i in 4" :span="12" :key="i">
                <div @click="rightQuarterSelect(i)" class="quarter_item" :class="[rightSelectActive(i),rightSelectDisable(i)?'disabled':'']">
                  {{$t('proprietor.rentAndVacancyHistorey.quarters.'+(i))}}
                </div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <div class="line"></div>
        <a-row style="margin-top: 10px;padding-left: 10px;margin-bottom: 5px;padding-right: 10px;">
          <a-col :span="24" style="text-align: right">
            <a-button @click="closePicker" key="submit" type="primary">{{$t('baseVO.confirm')}}</a-button>
          </a-col>
        </a-row>
      </div>
    </a-popover>
  </div>

</template>

<script>
  import moment from 'moment'
  export default {
    name: 'ptQuarterRange',
    props:{
      allowClear:{
        default: true,
      },
      value:{
        default:undefined,
      }
    },
    data() {
      return {
        mode1: 'time',
        mode2: ['month', 'month'],
        dateValue:this.value?this.value:[],
        dateValueStr:[],
        leftYear:2018,
        rightYear:2020,
        leftQuarter:1,
        rightQuarter:1,
        showLeftYear:2018,
        showRightYear:2020,
        showLeftQuarter:1,
        showRightQuarter:1,
        open:false,
        minYear:2018,
        maxYear:moment().quarter() == 1 ? moment().year()-1 : moment().year(),
        maxYearMaxQuarter:moment().quarter() == 1?4:moment().quarter()-1
      }
    },
    mounted(){

    },
    watch:{
      value(newValue){
        this.dateValue = newValue
        if(this.value && this.value.length == 2){
          this.leftYear = this.value[0].year()
          this.leftQuarter = this.value[0].month()+1
          this.rightQuarter = this.value[1].month()+1
          this.rightYear = this.value[1].year()>this.maxYear?this.maxYear:this.value[1].year()
        }
      },
      leftQuarter(newValue){
        this.showLeftQuarter = newValue
        this.showLeftYear = this.leftYear
        this.showRightQuarter = this.rightQuarter
        this.showRightYear = this.rightYear
      },
      rightQuarter(newValue){
        this.showLeftQuarter = this.leftQuarter
        this.showLeftYear = this.leftYear
        this.showRightQuarter = newValue
        this.showRightYear = this.rightYear
      },
      leftYear(newValue){
        if(newValue < this.minYear){
          this.leftYear = this.minYear
        }
        if(newValue > this.maxYear){
          this.leftYear = this.maxYear
        }
        if(newValue == this.rightYear){
          if(this.leftQuarter == this.rightQuarter){
            this.rightQuarter = this.rightQuarter + 1;
          }
        }
      },
      rightYear(newValue){
        if(newValue < this.minYear){
          this.rightYear = this.minYear
        }
        if(newValue > this.maxYear){
          this.rightYear = this.maxYear
        }
        if(newValue == this.leftYear){
          if(this.leftQuarter == this.rightQuarter){
            this.rightQuarter = this.rightQuarter + 1;
          }
        }
      },
    },
    methods:{
      leftSelectActive(i){
        if(i==this.leftQuarter && this.leftYear <= this.rightYear){
          return "active"
        }
      },
      leftSelectDisabled(i){
        if(this.leftYear > this.rightYear){
          return 'disabled'
        }
        if(this.leftYear == this.rightYear && i>=this.rightQuarter){
          return 'disabled'
        }
      },
      rightSelectActive(i){
        if(i == this.rightQuarter){
          if(this.leftYear != this.rightYear){
            return 'active'
          }else{
            if(this.rightQuarter != this.leftQuarter){
              return 'active'
            }
          }
        }
      },
      rightSelectDisable(i){
        if(this.leftYear > this.rightYear){
          return 'disabled'
        }
        if(this.leftYear == this.rightYear){
          if(i<=this.leftQuarter){
            return 'disabled'
          }
        }
        if(this.rightYear == this.maxYear){
          if(i > this.maxYearMaxQuarter){
            return 'disabled'
          }
        }
      },
      leftQuarterSelect(i){
        if(this.leftSelectDisabled(i) != 'disabled'){
          this.leftQuarter = i;
        }
      },
      rightQuarterSelect(i){
        if(this.rightSelectDisable(i) != 'disabled'){
          this.rightQuarter = i;
        }
      },
      openSelect(){
        this.open=true
      },
      handlePanelChange (value){
        this.$emit('input',value)
        this.dateValue = value
        // this.$emit('change',value)
      },
      handleOpenChange (status) {
        if(status){
          this.open = true
        } else {
          this.open = false
        }
      },
      closePicker(){
        this.dateValue = [moment(this.leftYear+"-"+this.leftQuarter),moment(this.rightYear+"-"+this.rightQuarter)]
        this.$emit('change',[this.leftYear+"Q"+this.leftQuarter,this.rightYear+"Q"+this.rightQuarter])
        this.$emit('input',this.dateValue)
        this.open = false;
      },
      clearValue () {
        this.dateValue = []
        this.$emit('change',[])
        this.$emit('input',[])
      },
    }
  }
</script>

<style scoped lang="less">
  .pickerButtonDiv{
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  .quarter_div{
    position: relative;
  }
  .picker_div{
    cursor: default;
    position: absolute;
    top:0px;
    right:-117px;
    z-index: 99;
    width: 530px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    user-select:none;
    padding: 5px;
    .select_value{
      height: 44px;
      display: flex;
      align-items: center;
      padding-left: 20px;
    }
    .line{
      border-bottom: 1px solid #e8e8e8;
    }
    .icon{
      cursor: pointer;
    }
    .disabled{
      color: rgba(0, 0, 0, 0.25);
      cursor: not-allowed;
    }
    .year-select{
      height: 38px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      padding-right: 20px;
      .year_select_col{
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .quarter_row{
      padding-top: 38px;
      .quarter_col{
        display: flex;
        justify-content: center;
      }
      .quarter_item{
        cursor: pointer;
        width: 70px;
        height: 25px;
        margin-bottom: 35px;
        line-height: 25px;
        text-align: center;
        padding: 0px 4px;
        border-radius: 2px;
      }
      .disabled{
        color: rgba(0, 0, 0, 0.25);
        background: #f5f5f5;
        cursor: not-allowed;
      }
      .active{
        color: #fff;
        background: #FABE00;
      }
    }

  }
</style>